// extracted by mini-css-extract-plugin
module.exports = {"page-container":"Page_page-container__V3_p_","inner":"Page_inner__w9soN","header":"Page_header__HceOT","title":"Page_title__ESjOS"};